import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_DATASET_NFT',
  name: 'Workspace Project Dataset Nft',
  type: 'PROJECT',
  description: '',
  modules: [],
  actions: ['READ', 'CREATE', 'UPLOAD', 'DESTROY'],
}

export default scope
